var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        {
          attrs: {
            title:
              "Edit Konfigurasi Loket Pendaftaran Online - " +
              _vm.metode_pendaftaran.nama,
          },
        },
        [
          _c(
            "b-card-text",
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-5",
                  attrs: { variant: "danger" },
                  on: { click: _vm.cancelEdit },
                },
                [_vm._v("Kembali")]
              ),
              _vm._v(" "),
              _c("form", { staticClass: "mt-5" }, [
                _c("div", { staticClass: "form-group row pb-4" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-lg-3 text-lg-end pt-2",
                      attrs: { for: "input-nama" },
                    },
                    [_vm._v("Tambah Loket Pendaftaran")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-6" },
                    [
                      _c("select2", {
                        attrs: {
                          id: "select-poli",
                          options: _vm.all_loket_pendaftaran_options,
                        },
                        on: { change: _vm.addLoketPendaftaran },
                        model: {
                          value: _vm.form.loket_pendaftaran,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "loket_pendaftaran", $$v)
                          },
                          expression: "form.loket_pendaftaran",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "mt-3",
                attrs: { id: "tabledata-metode-pendaftaran" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }